import { render, staticRenderFns } from "./CartSidebarPrice.vue?vue&type=template&id=54fb3298&scoped=true"
import script from "./CartSidebarPrice.vue?vue&type=script&setup=true&lang=ts"
export * from "./CartSidebarPrice.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CartSidebarPrice.vue?vue&type=style&index=0&id=54fb3298&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fb3298",
  null
  
)

export default component.exports